<script setup lang="ts">
import { computed, onMounted } from "vue";
import { useSitesStore } from "@/stores/v2";
import { SitesService } from "@/services/v2/sites";
import { useLoading } from "@/composables/useLoading";

import SitesList from "@/components/v2/Dashboard/Sites/Lists/SitesList.vue";
import LayoutMain from "@/components/v2/Layouts/LayoutMain.vue";
import LoadingScreen from "@/components/v2/Loaders/LoadingScreen.vue";

const { withLoading, isLoading } = useLoading();

const sites = computed(() => useSitesStore().getSites);

const init = async () => {
    await withLoading(async () => {
        const sites = await SitesService.getUserSites();
        useSitesStore().setSites(sites)
    })
};

onMounted(init);
</script>
<template>
    <LoadingScreen v-if="isLoading" :text="'Loading sites'" />
    <LayoutMain v-else>
        <template #mainArea>
            <SitesList :sites="sites" />
        </template>
    </LayoutMain>
</template>
